<div class="d-flex flex-column advanced-search"
     [ngClass]="{'overflow-hidden': !advancedSearchOpen}">
  <div class="advanced-search-control"
       (click)="advancedSearchOpen = !advancedSearchOpen">
    <div>
      @if (advancedSearchOpen) {
        <reporter-icon
          icon="Expanded"></reporter-icon>
      }
      @if (!advancedSearchOpen) {
        <reporter-icon
          icon="Collapsed"></reporter-icon>
      }
      <span class="pl-3">Location Search Criteria</span>
    </div>
  </div>
  <form role="form"
        #form="ngForm"
        class="px-2">
    @if (advancedSearchOpen) {
      <div
        class="advanced-search-form row mx-0 py-2">
        <div class="form-group col-12 col-md-6">
          <label>Name</label>
          <input type="text"
                 name="name"
                 placeholder="Name"
                 [(ngModel)]="searchModel['name']"
                 class="form-control"/>
        </div>
        <div class="form-group col-12 col-md-6">
          <label>{{ buReferenceNumberPrompt }}</label>
          <input type="text"
                 name="referenceNumber"
                 [placeholder]="buReferenceNumberPrompt"
                 [(ngModel)]="searchModel['referenceNumber']"
                 class="form-control"/>
        </div>
        <div class="form-group col-12 col-md-6">
          <label>Address</label>
          <input type="text"
                 name="address"
                 placeholder="Address"
                 [(ngModel)]="searchModel['address']"
                 class="form-control"/>
        </div>
        <div class="form-group col-12 col-md-6">
          <label>City</label>
          <input type="text"
                 name="city"
                 placeholder="City"
                 [(ngModel)]="searchModel['city']"
                 class="form-control"/>
        </div>
        <div class="form-group col-12 col-md-6">
          <label>State</label>
          <select
            class="form-control"
            name="jurisdiction"
            [class.placeholder]="!searchModel['jurisdiction']"
            [(ngModel)]="searchModel['jurisdiction']">
            <option [ngValue]="undefined">State</option>
            @for (jurisdiction of jurisdictions; track jurisdiction; let index = $index) {
              <option
                [ngValue]="jurisdiction.key">{{ jurisdiction.displayValue }}
              </option>
            }
          </select>
        </div>
        <div class="form-group col-12 col-md-6">
          <label>Postal Code</label>
          <input type="text"
                 class="form-control"
                 name="postalCode"
                 placeholder="Postal Code"
                 [(ngModel)]="searchModel['postalCode']">
        </div>
        <div class="form-group col-12 col-md-6">
          <label>Phone</label>
          <reporter-phone
            name="phone"
            placeholder="Phone"
            [(ngModel)]="searchModel['phone']"></reporter-phone>
        </div>
        <div class="form-group col-12 col-md-6 pt-4">
          <div class="custom-control custom-checkbox">
            <input type="checkbox"
                   class="custom-control-input"
                   id="reportingLocationsOnly"
                   [checked]="searchModel['reportingLocationsOnly'] === true"
                   (change)="searchModel['reportingLocationsOnly'] = !searchModel['reportingLocationsOnly']"
                   [disabled]="reportingLocationsOnly"/>
            <label class="custom-control-label"
                   for="reportingLocationsOnly">Reporting Locations Only</label>
          </div>
        </div>
        <div class="d-flex col-12 justify-content-end align-items-center py-2 py-lg-0">
          <button type="button"
                  class="btn btn-action"
                  data-test-id="search-form-clear"
                  (click)="resetForm()">CLEAR
          </button>
          <button type="submit"
                  class="btn btn-action ml-3"
                  (click)="submit()">SEARCH
          </button>
        </div>
      </div>
    }
  </form>
</div>
@if (searchResults) {
  <div
    class="results-count">{{ totalRecords }} record{{ totalRecords !== 1 ? 's' : '' }} found
  </div>
}
@if (searchResults?.length) {
  <div class="search-results"
       infiniteScroll
       [scrollWindow]="false"
       [infiniteScrollDistance]="1"
       [infiniteScrollThrottle]="50"
       [infiniteScrollDisabled]="pageNumber >= totalPages"
       (scrolled)="loadNextPage()">
    <div class="results-list">
      @for (bu of searchResults; track bu; let index = $index) {
        <div
          class="list-group-item"
          [class.zebra]="index % 2 == 1">
          <div class="reporting-location col">
            <div class="d-flex align-middle justify-content-between">
              <div>
                @if (systemClientSelected) {
                  <span style="font-weight: bold;">
                    {{ '[' + bu.gbClientNumber + ']' }}
                  </span>
                }
                <span [innerHTML]="highlightName(bu.displayName)"></span>
              </div>
              <button
                type="button"
                class="btn btn-action py-0"
                [class.cursor-not-allowed]="reportingLocationsOnly && !bu.reportingLocation"
                (click)="emitSelected(bu)">
                Select
              </button>
            </div>
            <reporter-business-unit-details
              [showClientNumber]="systemClientSelected"
              [buDetails]="bu"
              [buReferenceNumberPrompt]="buReferenceNumberPrompt"
              [searchCriteria]="searchModel">
            </reporter-business-unit-details>
          </div>
        </div>
      }
    </div>
  </div>
}
